import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Card, Button, Icon, Typography, LinearProgress } from 'material-ui';
import { getSatisfactionSurveysData, calculateTotal } from '../../controllers/SatisfationResults';
import { SATISFACTION } from '../../config/constants';
import StackedBarChart from '../chartComponents/StackedBarChart';
import * as moment from 'moment';
import DatePickerCustom from '../displayComponents/DatePickerCustom';
import SelectComponent from '../displayComponents/SelectComponent';
import icon_pdf from '../../resources/images/icon_pdf.png';
import jsPDF from 'jspdf';
import { validateDatesFilter } from '../SurveyResults/SurveyResultsContainer';
import { toast } from 'react-toastify';
import { getFilterText, setHeader, setGraphic, setTable, setFooter } from '../../utils/utils';

class SatisfationResultsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            loading: true,
            data: [],
            totalData: [],
            excellData: [],
            filter: {
                questions: SATISFACTION,
                from: moment()
                .subtract(3, "month")
                .format("DD/MM/YYYY 00:00"),
                to: moment().format("DD/MM/YYYY 23:59"),
                office: -1,
                municipality: -1
            },
            barKeys: [{
                label: "Mal",
                key: "2"
            }, {
                label: "Regular",
                key: "4"
            }, {
                label: "Ben",
                key: "5"
            }],
            filename: "resultados_satisfaccion" + moment().format('DD-MM-YYYY'),
            title: "Estadísticas das enquisas de satisfacción"
        }
    }

    componentDidMount() {
        const { sessionData } = this.props.main;
        if (sessionData.municipality){
            this.setState({ filter: { ...this.state.filter,  municipality: sessionData.municipality} }, async ()=>{
                this.loadData();
            })
        } else{
            this.loadData();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) {
            this.loadData();
        }
    }

    loadData = async () => {
        try {
            const { filter, barKeys } = this.state;
            const { sessionData } = this.props.main;
            let data = await getSatisfactionSurveysData(sessionData.userName, sessionData.passwd, filter);
            let total = calculateTotal(data, barKeys);
            this.setState({ data: data, totalData: total });
            this.setState({ loading: false });
        } catch (err) {
            console.error(err);
        }
    }

    updateFilter = (value, name) => {
        if (
            !validateDatesFilter(this.state.filter.from, this.state.filter.to, {
                value: value,
                name: name
            })
        ) {
            toast("A data elexida no é válida", {
                className: "toast-error",
                autoClose: 2000
            });
        } else {
            let filter = {};
            filter[name] = value;
            if(name === 'municipality') filter.office = -1;
            this.setState({ filter: { ...this.state.filter, ...filter } }, this.loadData);
        }
    };

    exportPdf = async () => {
        this.setState({ downloading: true });

        try {
            const { offices, municipalities } = this.props.main;
            const { title, filter } = this.state;
            let doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
            let filter_text = getFilterText(filter, municipalities, offices);
            setHeader(doc, title, `Período: ${filter.from} a ${filter.to} ${filter_text}`);
            await setGraphic(doc, `graphic`);
            await setTable(doc, `tableAux`);
            setFooter(doc, 1, 1);
            doc.save(this.state.filename);
        } catch (err) {
            console.error(err);
        }
        this.setState({ downloading: false });
    }

    render() {
        const { data, barKeys, totalData, filter: { from, to, office, municipality }, excellData, filename, loading, downloading } = this.state;
        const { offices, municipalities, sessionData } = this.props.main;
        return (
            <Fragment>
                <Grid item xs={12}>
                    <Card elevation={0} style={{ padding: '0.5em 1em' }}>
                        <Grid container spacing={16}>
                            <Grid item xs={4}>
                                <div style={{ flexDirection: 'column' }}>
                                    <DatePickerCustom
                                        label="Dende"
                                        value={from}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "from");
                                        }}
                                    />
                                    <DatePickerCustom
                                        label="Ata"
                                        value={to}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "to");
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <SelectComponent
                                    disabled={!!sessionData.municipality}
                                    label="Concello"
                                    defaultValue="Todos"
                                    items={municipalities}
                                    value={municipality}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "municipality");
                                    }} />
                                <SelectComponent
                                    label="Oficina"
                                    defaultValue="Todas"
                                    items={(!!municipality && municipality != -1) ? offices.filter((office) => { return office.municipality_id === municipality }) : offices}
                                    value={office}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "office");
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ flexDirection: 'column', marginRight: '-1em' }}>
                                    <Button disabled={downloading} style={{
                                            backgroundColor: "#DDD",
                                            marginTop: '0.5em',
                                            float: 'right',
                                            marginRight: '1em'
                                        }} onClick={this.exportPdf}>
                                            Exportar gráficas en pdf
                                        <Icon style={{
                                                marginLeft: "0.8rem",
                                                color: "#f53838"
                                            }}>
                                                <img src={icon_pdf} alt="Exportar como pdf" />
                                            </Icon>
                                    </Button>
                                    {/* <ExcelFile
                                        filename={filename}
                                        element={
                                            <Button style={{
                                                backgroundColor: "#DDD",
                                                marginTop: '0.5em',
                                                float: 'right',
                                                marginRight: '1em'
                                            }}>
                                                Exportar excel
                                                <Icon>
                                                    <img src={icon_excel} alt="Exportar como excel" />
                                                </Icon>
                                            </Button>
                                        }>
                                        {excellData.map(item => {
                                            return (
                                                <ExcelSheet
                                                    key={item.key}
                                                    data={item.data}
                                                    name={item.columns[0].label}>
                                                    {item.columns.map(column => {
                                                        return (
                                                            <ExcelColumn
                                                                key={`${item.key}_${column.value}`}
                                                                label={column.label}
                                                                value={column.value}
                                                            />
                                                        );
                                                    })}
                                                </ExcelSheet>
                                            );
                                        })}
                                    </ExcelFile> */}
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                {loading ?
                    <Card style={{ width: '100%' }}>
                        <Typography variant="headline" component="h4">Cargando visitas...{" "}</Typography>
                        <LinearProgress />
                    </Card>
                    :
                    <React.Fragment>
                        <Grid item xs={12} md={8} xl={9}>
                            <StackedBarChart
                                data={data}
                                vertical="vertical"
                                dataKeyY="question"
                                colors={["#ff5252", "#afb42b", "#448aff"]}
                                barKeys={barKeys}
                                id="graphic"
                            />
                        </Grid>
                        <Grid item xs={12} md={4} xl={3} >
                            <div style={{ margin: '1em', width: 'calc(100% - 2em)' }}>
                                <Table id="tableAux">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ padding: '4px 0px 4px 4px' }}>Cuestión</TableCell>
                                            {barKeys.map((bar) => {
                                                return (
                                                    <TableCell style={{ padding: '4px', textAlign: 'right' }} key={bar.key}>{bar.label}</TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((item) => {
                                            return (
                                                <TableRow key={`${item.field}`}>
                                                    <TableCell style={{ padding: '4px 0px 4px 4px' }}>{item.question}</TableCell>
                                                    {barKeys.map((bar) => {
                                                        return (
                                                            <TableCell style={{ padding: '4px', textAlign: 'right' }} key={`${item.field}_${bar.key}`}>{item[bar.key] ? item[bar.key] : 0}</TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                        <TableRow style={{ fontWeight: 'bold' }}>
                                            <TableCell style={{ padding: '4px 0px 4px 4px' }}>Total</TableCell>
                                            {totalData.map((totalItem) => {
                                                return (
                                                    <TableCell style={{ padding: '4px', textAlign: 'right' }} key={`total_${totalItem.key}`}>{totalItem.total}</TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </TableBody>
                                </Table>

                            </div>
                        </Grid>

                    </React.Fragment>
                }
                {/* </Grid> */}
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SatisfationResultsContainer);



// WEBPACK FOOTER //
// ./src/components/SatisfactionResults/SatisfationResultsContainer.js